export default [
  {
    path: '*',
    redirect: '/404',
    meta: { requiresAuth: true }
  },
  {
    path: '/404',
    meta: { requiresAuth: true },
    component: () => import('@/pages/404.vue')
  }
]
